<div class="fui-content-filter">
  <div class="d-flex align-items-center flex-wrap">
    @if (showSidebarToggle) {
      <button class="text-nowrap m-y-5 refine-btn" (click)="refine()">
        <fa-icon [icon]="refining ? 'chevron-left' : 'bars'"></fa-icon>
        {{ refining ? ("my_gear.hide_filters" | translate) : ("my_gear.show_filters" | translate) }}
      </button>
      <button class="text-nowrap m-y-5 refine-btn-mobile" (click)="showMobileFilters()">
        <fa-icon icon="bars"></fa-icon>
        {{ "my_gear.show_filters" | translate }}
      </button>
    }

    @if (filters) {
      @if (filters.product != "any") {
        <div class="m-l-10 text-nowrap m-y-5">
          {{ "my_gear.product" | translate }}:
          {{ contentService.productsAssociatedWithVideosMap[filters.product] ? contentService.productsAssociatedWithVideosMap[filters.product].title : filters.product }}
          <button (click)="clearFilter.next('product')"><fa-icon icon="times"></fa-icon></button>
        </div>
      }
      @if (filters.tag != "any") {
        <div class="m-l-10 text-nowra m-y-5">
          {{ "my_gear.tag" | translate }}: {{ contentService.tagsAssociatedWithVideosMap[filters.tag] ? contentService.tagsAssociatedWithVideosMap[filters.tag].title : filters.tag }}
          <button (click)="clearFilter.next('tag')"><fa-icon icon="times"></fa-icon></button>
        </div>
      }
      @if (filters.duration != "any") {
        <div class="m-l-10 text-nowrap m-y-5">
          {{ "my_gear.duration" | translate }}: {{ contentService.durationMap[filters.duration] }}
          <button (click)="clearFilter.next('duration')"><fa-icon icon="times"></fa-icon></button>
        </div>
      }
    }
  </div>
  <div class="d-flex align-items-center">
    @if (showSearchInput) {
      <div class="fui-sidebar-search m-r-20" [class.wider]="widerSearch">
        <input
          type="text"
          [placeholder]="searchPlaceholder | translate"
          [(ngModel)]="activeQuery"
          id="content-filter-search"
          (keyup.enter)="queryChanged.next(activeQuery)"
          (ngModelChange)="queryChangedEvent($event)"
        />
      </div>
    }
    @if (showSortOptionsToggle) {
      <div class="fui-content-filter-sort-by m-r-20" (clickOutside)="showSortOptions = false">
        <button class="text-nowrap m-y-5" (click)="showSortOptions = !showSortOptions">
          {{ "my_gear.sort_by" | translate }}
          <span [class.rotate90]="showSortOptions" [class.unrotate90]="!showSortOptions" class="d-inline-block">
            <fa-icon icon="chevron-right"></fa-icon>
          </span>
        </button>
        <div class="sort-by-options" [showIf]="showSortOptions" animateIn="down">
          <div class="options">
            <button (click)="sortBy('abc')" class="m-b-5" [class.selected]="settings.sort_by == 'abc'">{{ "my_gear.title" | translate }}</button>
            <button (click)="sortBy('date')" [class.selected]="settings.sort_by == 'date'">{{ "my_gear.date" | translate }}</button>
          </div>
          <div class="direction">
            <button (click)="sortDirection('asc')" class="m-b-5" [class.selected]="settings.sort_direction == 'asc'">{{ "my_gear.ascending" | translate }}</button>
            <button (click)="sortDirection('desc')" [class.selected]="settings.sort_direction == 'desc'">{{ "my_gear.descending" | translate }}</button>
          </div>
        </div>
      </div>
    }
    @if (showViewOption) {
      <div class="fui-content-filter-view-as m-r-20 m-y-5">
        {{ "my_gear.view" | translate }}
        <button [class.active]="appService.prefersGrid" (click)="appService.prefersGrid = true"><fa-icon icon="table-cells-large"></fa-icon></button>
        <button [class.active]="!appService.prefersGrid" (click)="appService.prefersGrid = false"><fa-icon icon="bars"></fa-icon></button>
      </div>
    }
    @if (showResults) {
      <div>
        <span class="t-14 bold text-nowrap m-y-5">{{ resultsCount }} {{ resultsCount == 1 ? ("my_gear.result_singular" | translate) : ("my_gear.results" | translate) }}</span>
      </div>
    }
  </div>
</div>
<div class="fui-sidebar-search-full m-r-20">
  <input
    type="text"
    [placeholder]="'my_gear.search' | translate"
    [(ngModel)]="activeQuery"
    (keyup.enter)="queryChanged.next(activeQuery)"
    (ngModelChange)="queryChangedEvent($event)"
  />
</div>
